export default class ProductPricingDataLayer {
	constructor(data, zone, totalPPSections) {
		if (window.dataLayer && data && totalPPSections) {
			this.dataLayer = window.dataLayer;
			this.rawData = data.slice();
			this.zone = zone;
			this.totalPPSections = totalPPSections;
			this.dataLayer.storeType = zone ? zone.toLowerCase() + ' - store' : null;
			this.dataLayer.pageType = 'Product';
			this.dataLayer.pageSubType = 'Product-Pricing';
			this.dataPPKeys = null;
			this.normalizedData = null;
			this.tabs = [].slice.call(document.querySelectorAll('.cmp-tabs__tab'));
			this.triggerTabClick = false;

			this.init();
		}
	}

	init() {
		if (this.tabs.length <= 0) {
			this.pageWithNoTabs();
		} else {
			this.pageWithTabs();
		}
	}

	pageWithNoTabs() {
		let normalizedData = this.normalizeData();

		// For pages with no tabs, add "NONE" for tabTitle.
		normalizedData = this.addTabTitles(normalizedData, 'NONE');

		if (this.dataLayer.items && this.dataLayer.items.length) {
			this.dataLayer.items.push(normalizedData);
		} else {
			this.dataLayer.items = [normalizedData];
		}

		if (this.allPPSectionsProcessed(false)) {
			this.flattenDataLayer();
			if (window._satellite) {
				window._satellite.track('Product View');
			}
		}
	}

	normalizeData() {
		let normalizedData = [];
		if (this.rawData && this.rawData.length) {
			for (let i = 0; i < this.rawData.length; i++) {
				if (this.rawData[i].products && this.rawData[i].products.length) {
					for (let j = 0; j < this.rawData[i].products.length; j++) {
						let rawProduct = this.rawData[i].products[j];
						let product = {};
						product['product-name'] = rawProduct.productTitle;
						product['product-sku'] = rawProduct.isFree && !rawProduct.dataLayerSku ? rawProduct.productTitle : rawProduct.dataLayerSku;
						product['product-price'] = this.formatPrice(rawProduct.displayPrice);
						product['product-currency'] = rawProduct.currency;
						normalizedData.push({ productInfo: product });
					}
				}
			}
		}
		return normalizedData;
	}

	addTabTitles(normalizedData, tabTitle) {
		for (const data of normalizedData) {
			data.tabTitle = tabTitle;
		}
		return normalizedData;
	}

	formatPrice(price) {
		if (price) {
			return price.replace(/[^0-9.-]+/g, '');
		} else {
			// Free or Contact Us products have undefined for price, change it to "0".
			return '0';
		}
	}

	allPPSectionsProcessed(hasTabs) {
		if (this.dataLayer.items) {
			if (hasTabs) {
				let ppSections = [].slice.call(document.querySelectorAll('.cmp-tabs__tabpanel--active .product-pricing-section'));
				return ppSections.length === this.dataLayer.items.length;
			} else {
				return this.totalPPSections === this.dataLayer.items.length;
			}
		}
	}

	flattenDataLayer() {
		let flattened = [];
		for (let i = 0; i < this.dataLayer.items.length; i++) {
			for (let j = 0; j < this.dataLayer.items[i].length; j++) {
				flattened.push(this.dataLayer.items[i][j]);
			}
		}
		this.dataLayer.items = flattened;
	}

	pageWithTabs() {
		let activeTabPPKeys = this.getActiveTabPPKeys();
		let dataPPKeys = this.getDataPPKeys();
		if (this.activeTabHasPPSection(activeTabPPKeys, dataPPKeys)) {
			this.triggerTabClick = true;

			this.normalizedData = this.normalizeData();
			if (this.dataLayer.items && this.dataLayer.items.length) {
				this.dataLayer.items.push(this.normalizedData);
			} else {
				this.dataLayer.items = [this.normalizedData];
			}
		}

		this.addTabsClick();

		if (this.allPPSectionsProcessed(true)) {
			this.flattenDataLayer();
			let tabTitle = [].slice.call(document.querySelectorAll('.cmp-tabs__tab--active'))[0].innerText;
			this.addTabTitles(this.dataLayer.items, tabTitle);
			if (window._satellite) {
				window._satellite.track('Product View');
			}
		}
	}

	getActiveTabPPKeys() {
		let activePPCards = [].slice.call(document.querySelectorAll('.cmp-tabs__tabpanel--active [data-cardid]'));
		let activeTabPPKeys = {};
		for (let i = 0; i < activePPCards.length; i++) {
			let key = activePPCards[i].getAttribute('data-cardid');
			activeTabPPKeys[key] = true;
		}
		return activeTabPPKeys;
	}

	getDataPPKeys() {
		if (this.dataPPKeys) {
			return this.dataPPKeys;
		}
		this.dataPPKeys = {};
		for (let i = 0; i < this.rawData.length; i++) {
			this.dataPPKeys[this.rawData[i].id] = true;
		}
		return this.dataPPKeys;
	}

	activeTabHasPPSection(activeTabPPKeys, dataPPKeys) {
		for (let key in dataPPKeys) {
			if (activeTabPPKeys[key]) {
				return true;
			}
		}
		return false;
	}

	addTabsClick() {
		let panels = [].slice.call(document.querySelectorAll('.cmp-tabs__tabpanel'));
		if (this.tabs.length) {
			for (let i = 0; i < panels.length; i++) {
				let panelPPKeys = this.getPanelPPKeys(panels[i]);
				if (this.panelHasPPSection(panelPPKeys, this.dataPPKeys)) {
					this.tabs[i].addEventListener('click', () => {
						this.onTabClick();
					});
				}
			}
		}
	}

	getPanelPPKeys(panel) {
		let ppCards = [].slice.call(panel.querySelectorAll('.cmp-tabs__tabpanel [data-cardid]'));
		let panelPPKeys = {};
		for (let i = 0; i < ppCards.length; i++) {
			let key = ppCards[i].getAttribute('data-cardid');
			panelPPKeys[key] = true;
		}
		return panelPPKeys;
	}

	panelHasPPSection(panelPPKeys, dataPPKeys) {
		for (let key in dataPPKeys) {
			if (panelPPKeys[key]) {
				return true;
			}
		}
		return false;
	}

	onTabClick() {
		this.dataLayer = window.dataLayer;
		this.removePrevDLItems();
		let activeTabPPKeys = this.getActiveTabPPKeys();
		let dataPPKeys = this.getDataPPKeys();
		if (this.activeTabHasPPSection(activeTabPPKeys, dataPPKeys)) {
			this.normalizedData = this.normalizeData();
			if (this.dataLayer.items && this.dataLayer.items.length) {
				this.dataLayer.items.push(this.normalizedData);
			} else {
				this.dataLayer.items = [this.normalizedData];
			}
		}

		if (this.allPPSectionsProcessed(true)) {
			this.flattenDataLayer();
			let tabTitle = [].slice.call(document.querySelectorAll('.cmp-tabs__tab--active'))[0].innerText;
			this.addTabTitles(this.dataLayer.items, tabTitle);

			if (!this.triggerTabClick) {
				this.triggerTabClick = true;
				if (window._satellite) {
					window._satellite.track('Tab Click');
				}
			}
		}
	}

	removePrevDLItems() {
		let newDataLayer = [];
		if (this.dataLayer.items) {
			for (let i = 0; i < this.dataLayer.items.length; i++) {
				if (Array.isArray(this.dataLayer.items[i])) {
					newDataLayer.push(this.dataLayer.items[i]);
				}
			}
		}
		window.dataLayer.items = newDataLayer;
	}
}
